export default __webpack_public_path__ + "static/media/arm_raise_jump_thumb.cbebbd7f.png";